"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANVAS_WRAPS_COLOR = exports.CANVAS_SIZES = void 0;
const tiles_1 = require("./tiles");
exports.CANVAS_SIZES = [
    tiles_1.TILE_SIZES.SQUARE_8X8,
    tiles_1.TILE_SIZES.RECTANGLE_8X11,
    tiles_1.TILE_SIZES.RECTANGLE_11X8,
    tiles_1.TILE_SIZES.HONEYCOMB_11X10,
    tiles_1.TILE_SIZES.SQUARE_12X12,
    tiles_1.TILE_SIZES.RECTANGLE_12X16,
    tiles_1.TILE_SIZES.RECTANGLE_16X12,
    tiles_1.TILE_SIZES.SQUARE_20X20,
    tiles_1.TILE_SIZES.RECTANGLE_20X27,
    tiles_1.TILE_SIZES.RECTANGLE_27X20,
    tiles_1.TILE_SIZES.RECTANGLE_27X36,
    tiles_1.TILE_SIZES.RECTANGLE_36X27,
    tiles_1.TILE_SIZES.RECTANGLE_22X44,
    tiles_1.TILE_SIZES.RECTANGLE_44X22
];
exports.CANVAS_WRAPS_COLOR = {
    WHITE: 'white'
};
//# sourceMappingURL=canvas.js.map